module.exports = __webpack_public_path__ + "static/img/coolbg.92fd0b03.png";